var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.385704 0.569727C0.526064 0.369335 0.755345 0.25 1 0.25H30C30.4142 0.25 30.75 0.585786 30.75 1V12C30.75 12.4142 30.4142 12.75 30 12.75H1C0.755345 12.75 0.526064 12.6307 0.385704 12.4303C0.245344 12.2299 0.211549 11.9736 0.29516 11.7437L0.679647 10.6864C1.66302 7.98207 1.66302 5.01793 0.679647 2.31365L0.29516 1.25631C0.211549 1.02638 0.245344 0.77012 0.385704 0.569727ZM2.07078 1.75L2.08934 1.80103C3.19312 4.83645 3.19312 8.16355 2.08934 11.199L2.07078 11.25H29.25V1.75H2.07078Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.385704 21.5697C0.526064 21.3693 0.755345 21.25 1 21.25H7.5C7.91422 21.25 8.25 21.5858 8.25 22C8.25 22.4142 7.91422 22.75 7.5 22.75H2.07078L2.08934 22.801C3.19312 25.8364 3.19312 29.1636 2.08934 32.199L2.07078 32.25H29.25V22.75H15C14.5858 22.75 14.25 22.4142 14.25 22C14.25 21.5858 14.5858 21.25 15 21.25H30C30.4142 21.25 30.75 21.5858 30.75 22V33C30.75 33.4142 30.4142 33.75 30 33.75H1C0.755345 33.75 0.526064 33.6307 0.385704 33.4303C0.245344 33.2299 0.211549 32.9736 0.29516 32.7437L0.679647 31.6864C1.66302 28.9821 1.66302 26.0179 0.679647 23.3136L0.29516 22.2563C0.211549 22.0264 0.245344 21.7701 0.385704 21.5697Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.621 22.4205C33.4815 22.6266 33.2489 22.75 33 22.75L29 22.75C28.5858 22.75 28.25 22.4142 28.25 22C28.25 21.5858 28.5858 21.25 29 21.25L31.9247 21.25C31.027 18.4882 31.027 15.5118 31.9247 12.75L4.75 12.75L4.75 22C4.75 22.4142 4.41421 22.75 4 22.75C3.58578 22.75 3.25 22.4142 3.25 22L3.25 12C3.25 11.5858 3.58578 11.25 4 11.25L33 11.25C33.2489 11.25 33.4815 11.3734 33.621 11.5795C33.7606 11.7856 33.7888 12.0475 33.6964 12.2785L33.6276 12.4505C32.4594 15.371 32.4594 18.629 33.6276 21.5495L33.6964 21.7215C33.7888 21.9525 33.7606 22.2144 33.621 22.4205Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H15C15.4142 16.25 15.75 16.5858 15.75 17V27C15.75 27.2809 15.593 27.5383 15.3432 27.6669C15.0934 27.7954 14.7927 27.7736 14.5641 27.6103L11.5 25.4217L8.43593 27.6103C8.20732 27.7736 7.90662 27.7954 7.65681 27.6669C7.40701 27.5383 7.25 27.2809 7.25 27V17ZM8.75 17.75V25.5426L11.0641 23.8897C11.3248 23.7034 11.6752 23.7034 11.9359 23.8897L14.25 25.5426V17.75H8.75Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileManagement);
export default __webpack_public_path__ + "static/media/FileManagement.2cc22f6a2737cea6354eb1c952d9b2fd.svg";
export { ForwardRef as ReactComponent };